import { Libraries, useJsApiLoader } from '@react-google-maps/api'
import { Loader } from '@percent/lemonade'

import { PlacesAutocomplete } from './places-autocomplete'
import type { AddressLookupProps } from './address-lookup.types'

const libraries = ['places'] as Libraries

export function AddressLookup(props: AddressLookupProps) {
  const { isLoaded } = useJsApiLoader({
    googleMapsApiKey: props.googleMapsApiKey,
    libraries,
  })

  if (!isLoaded) return <Loader />

  return <PlacesAutocomplete {...props} />
}
